<template>
    <div v-bind:class="{ 'loading loading-machines': !init || loading}">
        <div v-if="init">
            <search-filter ref="filter" v-on:new-filter="newFilter" :use-brand-filter="useBrandFilter" :use-format-filter="useFormatFilter" :format="format" :formats="formats" :texts="texts" :brand="brand" :brands="brands" :year="year" :years="years" :sorting="sorting" :sortings="sortings"></search-filter>
            <div v-if="oneMachineBrand" class="section-filter-brand">
                <div class="container">
                    <h1>{{ htmlBrand }}</h1>
                    <truncate :clamp="texts.more" :length="450" :less="texts.less" type="html" :text="htmlBrandDescription" class="collapsed-info"></truncate>
                </div>
            </div>
            <div class="section-machines" v-show="total > 0">
                <div class="container">
                    <div class="machines">
                        <machine v-for="m in machines" :key="m.url" :texts="texts" :machine="m"></machine>
                    </div>
                    <div class="buttons" v-show="isLoadMoreVisible">
                        <a v-on:click.prevent="clickLoadMore" class="btn btn-black btn-lg" :disabled="loading">{{ texts.next_Count }}</a>
                    </div>
                </div>
            </div>
            <div class="section-btn-box section-no-machines" v-show="total == 0">
                <div class="container">
                    <h2 class="h1">
                        {{ texts.noMachines }}
                    </h2>
                    <p class="description">
                        {{ texts.noMachines_Description }}
                    </p>
                    <p class="buttons">
                        <a class="btn btn-primary btn-lg" v-bind:href="urls.haveNotFound">{{ texts.notFindMachine }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    var axios = require('axios')
    import Machine from './_machine.vue'
    import SearchFilter from './_search-filter.vue'
    import truncate from 'vue-truncate-collapsed';
    var url = require('url');

    export default {
        name: 'app',
        components: {
            Machine,
            SearchFilter,
            truncate
        },
        data() {
            return {
                loading: false,
                init: false,
                machines: [],
                brands: [],
                sorting: __SEARCH_CONFIG__.sorting,
                year: __SEARCH_CONFIG__.year,
                format: __SEARCH_CONFIG__.format,
                brand: __SEARCH_CONFIG__.brand,
                sortings: [],
                formats: [],
                years: [],
                total: 0,
                language: __L__,
                oneMachineBrand: __SEARCH_CONFIG__.oneMachineBrand,
                rewriteId: __SEARCH_CONFIG__.rewriteId,
                page: 1,
                pageSize: 18,
                texts: [],
                urls: [],
                useFormatFilter: __SEARCH_CONFIG__.useFormatFilter,
                useBrandFilter: !__SEARCH_CONFIG__.oneMachineBrand
            }
        },
        props: {
            htmlBrand: {
                type: String
            },
            htmlBrandDescription: {
                type: String
            }
        },
        computed: {
            isLoadMoreVisible() {
                var self = this
                if (self.pageSize * self.page < self.total) {
                    return true
                }

                return false
            }
        },
        created() {
            let self = this;

            self.brand = __SEARCH_CONFIG__.brands;

            if (__SEARCH_CONFIG__.oneMachineBrand) {
                self.useBrandFilter = false;
            }

            self.fetch(true);

        },
        methods: {
            newFilter() {
                var self = this;
                var filter = self.$refs.filter;
                self.brand = filter.sbrand;
                self.year = filter.syear;
                self.sorting = filter.ssorting;
                self.format = filter.sformat;
                self.fetch(true);
            },
            clickLoadMore() {
                var self = this;
                self.fetch(false);
            },
            fetch(reset) {
                reset = reset || false;
                var self = this;

                if (self.loading) return;

                self.loading = true;

                if (reset) {
                    self.page = 0;
                }

                axios.get('/api/machines', {
                    params: {
                        language: self.language,
                        page: self.page + 1,
                        sorting: self.sorting,
                        machineBrandIds: self.brand.map(b => b.id),
                        yearsManufactured: self.year,
                        rewriteId: self.rewriteId,
                        format: self.format,
                        oneMachineBrand: self.oneMachineBrand
                    }
                }).then(response => {
                    var newMachines = response.data.machines;

                    if (reset) {
                        self.machines = [];
                    }

                    for (var i = 0; i < newMachines.length; i++) {
                        var machine = newMachines[i];
                        self.machines.push(machine);
                    }

                    self.formats = response.data.formats;
                    self.format = response.data.format;
                    self.sorting = response.data.sorting;
                    self.brand = response.data.brand;
                    self.year = response.data.year;
                    self.sortings = response.data.sortings;
                    self.brands = response.data.brands;
                    self.years = response.data.years;
                    self.texts = response.data.texts;
                    self.urls = response.data.urls;
                    self.total = response.data.total;
                    self.page++;
                    self.loading = false;
                    self.init = true;
                    $('#search-pdf-link').attr('href', self.urls.pdf);                    

                    if (window.history.replaceState) {
                        var u = url.parse(window.location.href);
                        var query = {};

                        if (self.sorting !== 5) {
                            query["srt"] = self.sorting
                        }

                        if (self.year.length > 0) {
                            query["y"] = self.year.join('.');
                        }

                        if (self.brand.length > 0 && !self.oneMachineBrand) {
                            query["mb"] = self.brand.map(b => b.url).join('.');
                        }

                        if (self.format.length > 0) {
                            query["frmt"] = self.format.join('.');
                        }

                        var nu = url.format({
                            pathname: u.pathname,
                            query: query
                        });

                        window.history.replaceState('', document.title, nu);
                    }
                })
                    .catch(error => {
                        self.init = true;
                        self.loading = false;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// search.vue?b0b76b16